import React from "react";
import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";
import Login from "./components/Login";
import OrganizationPortal from "./components/OrganizationPortal";
import CompanySignup from "./components/CompanySignup";
import SetPassword from "./components/SetPassword";
import SuperAdminDashboard from "./components/SuperAdminDashboard";
import UpdatePassword from "./components/UpdatePassword";

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/set-password" element={<SetPassword />} />
        <Route path="/company-signup" element={<CompanySignup />} />
        <Route
          path="/organization-portal/:companyId/*"
          element={<OrganizationPortal />}
        />
        <Route
          path="/super-admin-dashboard"
          element={<SuperAdminDashboard />}
        />
        <Route path="/update-password" element={<UpdatePassword />} />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    </Router>
  );
};

export default App;
